var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_5350)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2653 1.2653C0 2.5306 0 4.56705 0 8.64V9.36C0 13.433 0 15.4694 1.2653 16.7347C2.5306 18 4.56705 18 8.64 18H9.36C13.433 18 15.4694 18 16.7347 16.7347C18 15.4694 18 13.433 18 9.36V8.64C18 4.56705 18 2.5306 16.7347 1.2653C15.4694 0 13.433 0 9.36 0H8.64C4.56705 0 2.5306 0 1.2653 1.2653ZM3.03754 5.47504C3.13504 10.155 5.47504 12.9675 9.57754 12.9675H9.81007V10.29C11.3176 10.44 12.4575 11.5425 12.915 12.9675H15.045C14.46 10.8375 12.9225 9.66004 11.9625 9.21004C12.9225 8.65504 14.2725 7.30504 14.595 5.47504H12.6599C12.2399 6.96004 10.9951 8.31004 9.81007 8.43754V5.47504H7.875V10.665C6.675 10.365 5.16004 8.91004 5.09254 5.47504H3.03754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_5350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVkWhite);
export default __webpack_public_path__ + "static/media/vk-white.75fa6543f2f55ad7237cf45440222328.svg";
export { ForwardRef as ReactComponent };